export default "__VITE_ASSET__CZp4VAU7__"